<template lang="pug">
    v-container.statistics
        v-layout(row wrap justify-space-between align-center)
            v-flex(xs12)
                member-statistics(v-if="isMember" :id="id")
                manager-statistics(v-else :id="id")

                // Chart
                chart
</template>

<script>
    import Layout from '../Layout/Layout';
    import Chart from './Chart';
    import Widgets from './Widgets';
    import MemberStatistics from './MemberStatistics';
    import ManagerStatistics from './ManagerStatistics';
    import { mapActions, mapGetters } from 'vuex';
    import VueTypes from 'vue-types';

    export default {
        components: {
            Layout,
            Chart,
            Widgets,
            MemberStatistics,
            ManagerStatistics
        },
        props: {
            id: VueTypes.string.def('')
        },
        computed: {
            ...mapGetters('auth', ['isAdmin', 'isChampion', 'isMember'])
        },
        beforeDestroy() {
            this.resetPeriod();
            this.resetFilters();
        },
        methods: {
            ...mapActions('statistics', ['resetPeriod', 'resetFilters'])
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../../assets/style/_variables.styl"

    .statistics
        margin-top: 20px

    .chartWrapper
        padding: 16px
        border-radius: 10px
        background: rgba(255, 255, 255, 0.1)
        box-shadow: 0 0 15px rgba(0, 0, 0, 0.1)

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .dateFilters
            margin-top: 10px
            flex-direction: column-reverse
            justify-content: flex-start
            align-items: flex-start

        .usersCounter
            font-size: 16px
            font-weight: 700
            margin-bottom: 10px
            margin-top: 0

        .statistics
            margin-top: 4px
            margin-bottom: 90px
</style>
